<div class="banner">
  <a class="banner__title" [sRouterLink]="'home'">
    <mat-icon>arrow_back</mat-icon>
    <app-block identifier="auth_logo"></app-block>
  </a>
  <a class="banner__title-mobile" [sRouterLink]="'home'">
    <mat-icon>arrow_back</mat-icon>
    <img
      loading="lazy"
      class="banner__logo"
      height="35"
      [src]="logo.url"
      [alt]="logo.title"
    />
  </a>
  <div class="banner__content">
    @if (title) {
      <h2 class="banner__heading">
        <app-block [identifier]="title()"></app-block>
      </h2>
    }
    @if (description) {
      <p class="banner__description">
        <app-block [identifier]="description()"></app-block>
      </p>
    }
  </div>
</div>
